import { useEffect } from 'react'

// Redux.
import { connect } from 'react-redux';

// Firebase.
import { auth } from '../firebaseHelper';
import { useAuthState } from 'react-firebase-hooks/auth';

// Components.
import LibraryContent from '../components/LibraryContent';
import BottomMenu from '../components/BottomMenu';
import BottomMenuLegalNote from '../components/BottomMenuLegalNote';
import SignedOutLibraryFeatures from '../components/SignedOutLibraryFeatures';
import { useNavigate } from 'react-router-dom';
import { navigateToSigninWithRedirect } from '../components/signinUtils';

export const Library = ({
    authenticated,
}) => {

    const [, userLoading] = useAuthState(auth);

    const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
    const navigate = useNavigate();

    const signinClick = () => {
        navigateToSigninWithRedirect(navigate, '/library');
    }

    useEffect(() => {
        const audio = document.getElementById('audio');
        audio.pause();
    }, [])

    return (
        <div className="container appScreen">
            <div className='main'>
                {!authenticated ?
                    <div className={`hasBottomMenu signedOutLandingPage signedOutLibraryPage${authenticated === false ? ' hasBottomMenuLegalNote' : ''}`}>
                        <main className='signedOutLibraryIntro'>
                            <h1 className='chatTitle homeHeroTitle'>Library</h1>
                            {authenticated === false && (
                                <>
                                    <p className='signedOutLibrarySubtitle'>Your listening, all in one place.</p>
                                    <SignedOutLibraryFeatures />
                                    <button type='button' onClick={signinClick} className='authSigninPill'>
                                        Sign in
                                    </button>
                                </>
                            )}
                        </main>

                        <BottomMenu bottomNote={authenticated === false ? <BottomMenuLegalNote /> : null} />
                    </div>
                    : userLoading ?
                    <div>
                        <div className='center'>
                            <div style={{ paddingBottom: `${safeAreaBottom + 20}px` }}>
                                <img className='glow icon' src='/icon.png' alt='' />
                            </div>
                        </div>
                    </div>
                    :
                    <LibraryContent />
                }
            </div>
        </div >
    )
}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(Library);
